import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { EMPTY, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { routes } from '../constants/routes';

export const profileDetailResolver: ResolveFn<any> = (route) => {
  const router = inject(Router);
  const apiService = inject(ApiService);

  const decryptedUserDetails = <
    {
      success: 'y' | 'n';
      data?: string;
      message?: string;
      isMultiplePhone?: boolean;
      isMultipleEmail?: boolean;
    }
  >route.queryParams;

  const handleEncryptionError = (errorMsg: string = 'Something went wrong') => {
    router.navigate(['/', routes.account, routes.login], {
      queryParams: {
        success: 'n',
        data: errorMsg,
      },
      replaceUrl: true,
    });
  };
  console.log('CALLED FROM PROFILE DETAIL RESOLVER');

  if (decryptedUserDetails?.success?.toLowerCase() !== 'y') {
    handleEncryptionError();
  }

  if (decryptedUserDetails?.isMultiplePhone) {
    try {
      const decoded = JSON.parse(
        decodeURIComponent(atob(decryptedUserDetails.data!)),
      );
      return of(decoded);
    } catch {
      handleEncryptionError('Failed to decode profile details');
      return EMPTY;
    }
  } else if (decryptedUserDetails?.isMultipleEmail) {
    try {
      const decoded = JSON.parse(
        decodeURIComponent(atob(decryptedUserDetails.data!)),
      );
      return of(decoded);
    } catch {
      handleEncryptionError('Failed to decode profile details');
      return EMPTY;
    }
  }

  return apiService.decrypyUserProfile(decryptedUserDetails.data!).pipe(
    tap((data) => {
      if (data?.multiplePhone && data?.multiplePhone.length > 1) {
        // Encode decrypted profile as base64 to avoid calling one-time token API again
        const encodedProfile = btoa(encodeURIComponent(JSON.stringify(data)));
        router.navigate(
          ['/', routes.account, routes.signUp, routes.multiplePhoneSignUp],
          { replaceUrl: true, queryParams: { profileDetails: encodedProfile } },
        );
      } else if (data?.isMultipleAccounts && data?.multipleEmails?.length > 1) {
        // Encode decrypted profile as base64 to avoid calling one-time token API again
        const encodedProfile = btoa(encodeURIComponent(JSON.stringify(data)));
        router.navigate(
          ['/', routes.account, routes.signUp, routes.multipleEmailSignUp],
          { replaceUrl: true, queryParams: { profileDetails: encodedProfile } },
        );
      }
    }),
    catchError((error) => {
      const errorMsg =
        error instanceof Error ? error.message : 'Something went wrong';
      handleEncryptionError(errorMsg);
      return EMPTY;
    }),
  );
};
